import React from 'react'
import busImage from '../../../../assets/img/bus_icon.png'
import styled from 'styled-components'
import { device } from '../../../../config/theme/breakpoints'

const BackdropContainer = styled.div`
    background: #EFEFEF;
    border-radius: 10px;
    width: 100%;

    @media ${device.tablet}{
        width: 48%;
    }
`
const ContainerInfo = styled.div`
    background: #F3F2F6;
    border-radius: 4px 4px 200px 4px;
    padding: 40px;

    > div:nth-child(1){
        text-align: right;
    }

    > div h3 {
        color: ${p => p.theme.palette.text.grayLight};

        > span {
            color: ${p => p.theme.palette.primary.main};
        }
    }

    > div:nth-child(4) p{
        text-decoration: underline;
        color: ${p => p.theme.palette.secondary.main};
    }
`

interface IOwnProps {
    title: string;
    fragmentTitle: string;
    description: string;
}

const FeatureItem: React.FunctionComponent<IOwnProps> = ({ title, fragmentTitle, description }) => {
  return (
    <BackdropContainer>
        <ContainerInfo>
            <div><img src={busImage} alt='Bus'/></div>
            <div><h3>{title}<span> {fragmentTitle}</span></h3></div>
            <div>{description}</div>
            <div><p>Ir al detalle</p></div>
        </ContainerInfo>
    </BackdropContainer>
  )
}

export default FeatureItem